/**
 * Badge del estado de un expediente (draft, submitted, eligible, approved,
 * disbursed, closed, rejected). Color-coded para escaneo rápido.
 */
import type { ProjectStatus } from "@/lib/api";
import { STATUS_LABELS } from "@/lib/api";

const PALETTE: Record<ProjectStatus, string> = {
  draft: "bg-slate-100 text-slate-700 ring-slate-200",
  submitted: "bg-brand-50 text-brand-700 ring-brand-200",
  eligible: "bg-amber-50 text-amber-800 ring-amber-200",
  approved: "bg-emerald-50 text-emerald-800 ring-emerald-200",
  disbursed: "bg-emerald-100 text-emerald-900 ring-emerald-300",
  closed: "bg-slate-200 text-slate-700 ring-slate-300",
  rejected: "bg-red-50 text-red-700 ring-red-200",
};

export function ProjectStatusBadge({
  status,
  className,
}: {
  status: ProjectStatus;
  className?: string;
}) {
  return (
    <span
      data-testid="project-status-badge"
      data-status={status}
      className={
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide uppercase ring-1 ring-inset " +
        PALETTE[status] +
        (className ? ` ${className}` : "")
      }
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
